import React, { useEffect, useState } from "react";
import {
	Spin,
	Table,
	Empty,
	Button,
	DatePicker,
	Select,
	Input,
	Tag,
} from "antd";
import { getLoggingPayment } from "../../../../apis/admin/loggingService";
import { combineUrlParams } from "./contsants";
import notificationHandler from "../../../atoms/Notification";
import { formatNumber } from "../../../helper";
import {
	DownloadOutlined,
	LoadingOutlined,
	SearchOutlined,
} from "@ant-design/icons";
import locale from "antd/es/date-picker/locale/vi_VN";
import { ColumnsType } from "antd/lib/table";
import "./Logging.scss";
const LoggingPayments = () => {
	const [loading, setLoading] = useState(false);
	const [dataLogging, setDataLogging] = useState([]);
	const [page, setPage] = useState(1);
	const [size, setSize] = useState(10);
	const [totalElement, setTotalElement] = useState(0);
	const [valueInput, setValueInput] = useState({
		custMsisdn: null,
		vtTransactionId: null,
		errorCode: null,
		fromDate: "",
		toDate: "",
	});
	const { RangePicker } = DatePicker;
	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	useEffect(() => {
		setLoading(true);
		const input = {
			...valueInput,
			size: size,
			page: page,
		};
		getLoggingPayment(combineUrlParams(input))
			.then((res) => {
				setDataLogging(res?.data?.data?.payload?.content);
				setTotalElement(res?.data?.data?.payload?.totalElements);
			})
			.catch(() => {})
			.finally(() => {
				setLoading(false);
			});
	}, [size, page]);
	const handleFilter = () => {
		setLoading(true);
		const input = {
			...valueInput,
			size: size,
			page: page,
		};
		getLoggingPayment(combineUrlParams(input))
			.then((res) => {
				setDataLogging(res?.data?.data?.payload?.content);
				setTotalElement(res?.data?.data?.payload?.totalElements);
			})
			.catch(() => {})
			.finally(() => {
				setLoading(false);
			});
	};
	useEffect(() => {
		setLoading(true);
		getLoggingPayment(
			combineUrlParams({
				page,
				size,
			})
		)
			.then((res) => {
				setDataLogging(res?.data?.data?.payload?.content);
				setTotalElement(res?.data?.data?.payload?.totalElements);
			})
			.catch(() => {})
			.finally(() => {
				setLoading(false);
			});
	}, []);
	const displayedIndex = (index: any) => (page - 1) * size + index + 1;
	const columns: ColumnsType<any> = [
		{
			title: "STT",
			dataIndex: "index",
			key: "index",
			align: "center",
			className: " min-w-[20px] ",
			render: (_: any, __: any, index: any) => displayedIndex(index),
		},
		{
			title: "Số điện thoại",
			dataIndex: "custMsisdn",
			key: "custMsisdn",
			align: "center",
			className: "min-w-[100px]",
		},
		{
			title: "Mã đơn hàng",
			dataIndex: "orderId",
			key: "orderId",
			align: "center",
			className: "min-w-[60px]",
			render: (value: any) => <Tag color="purple">{value}</Tag>,
		},
		{
			title: "Mã đối tác",
			dataIndex: "merchantCode",
			key: "merchantCode",
			align: "center",
			className: "min-w-[150px]",
		},
		{
			title: "Số điện thoại đối tác",
			dataIndex: "merchantMsisdn",
			key: "merchantMsisdn",
			align: "center",
			className: "min-w-[70px]",
		},
		{
			title: "Số tiền thanh toán",
			dataIndex: "transAmount",
			key: "transAmount",
			align: "center",
			className: "min-w-[120px]",
			render: (value: any) => {
				return formatNumber(Number(value));
			},
		},
		{
			title: "Mã lỗi",
			dataIndex: "errorCode",
			key: "errorCode",
			align: "center",
			className: "min-w-[50px]",
			render: (value: any) => <Tag color="volcano">{value}</Tag>,
		},
		{
			title: "Chi tiết lỗi",
			dataIndex: "errorMessage",
			key: "errorMessage",
			align: "center",
			className: "min-w-[200px] max-w-[200px] ",
			render: (value: any) => (
				<p
					className="overflow-hidden text-ellipsis whitespace-nowrap"
					title={value}
				>
					{value}
				</p>
			),
		},
		{
			title: "Mã giao dịch",
			dataIndex: "vtTransactionId",
			key: "vtTransactionId",
			align: "center",
			className: "min-w-[100px]",
		},
		{
			title: "Check sum",
			dataIndex: "checkSum",
			key: "checkSum",
			align: "center",
			className: "min-w-[100px]",
			render: (value) => <p className="text-left">{value}</p>,
		},
		{
			title: "Thời gian",
			dataIndex: "createdAt",
			key: "createdAt",
			align: "center",
			className: "min-w-[100px]",
		},
	];
	const handleChangeErrorCode = (value: any) => {
		setValueInput({
			...valueInput,
			errorCode: value,
		});
	};
	const onchangeDate = (date: any, dateString: any) => {
		setValueInput({
			...valueInput,
			fromDate: dateString[0],
			toDate: dateString[1],
		});
	};
	const handleChangeTransactionId = (paymentStatus: any) => {
		setValueInput({
			...valueInput,
			vtTransactionId: paymentStatus,
		});
	};

	const handleChangePhoneNumber = (number: any) => {
		setValueInput({
			...valueInput,
			custMsisdn: number,
		});
	};
	return (
		<div id="logging" className="px-[20px]">
			<Spin indicator={antIcon} spinning={loading} />
			<div>
				<div className="flex justify-between my-3">
					<div className="flex w-[70%]">
						<RangePicker
							onChange={onchangeDate}
							placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
							// format={dateFormat}
							locale={locale}
							className="w-[35%] cursor-pointer"
						/>
						<Input
							className="w-[25%] ml-3"
							placeholder="Sô điện thoại"
							onChange={(e) => handleChangePhoneNumber(e.target.value)}
							onKeyPress={(event) => {
								if (!/[0-9]/.test(event.key.trim())) {
									event.preventDefault();
								}
							}}
							maxLength={10}
							allowClear
						></Input>

						<Input
							className="w-[25%] ml-3 pl-[20px]"
							placeholder="Mã giao dịch"
							onChange={(e) => handleChangeTransactionId(e.target.value)}
							allowClear
						></Input>

						<Input
							className="w-[25%] ml-3"
							placeholder="Mã lỗi"
							onChange={(e) => handleChangeErrorCode(e.target.value)}
							allowClear
						></Input>

						<Button
							icon={<SearchOutlined />}
							// loading={loading}
							onClick={handleFilter}
							className="ml-3 text-white bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
						>
							Tìm kiếm
						</Button>
					</div>
				</div>
			</div>
			<Table
				dataSource={dataLogging}
				columns={columns}
				pagination={{
					locale: { items_per_page: "bản ghi / Trang" },
					current: page,
					defaultPageSize: size,
					total: totalElement,
					onChange: (value: any) => setPage(value),
					showSizeChanger: true,
					pageSizeOptions: ["10", "20", "50"],
					onShowSizeChange(current, size) {
						setSize(size);
					},
					showTotal: (total: any, range: any) => ` Tổng ${total} bản ghi`,
				}}
				rowKey={(record: any) => record.id}
				className="mt-[15px] overflow-auto"
				locale={{
					emptyText: (
						<Empty
							image={Empty.PRESENTED_IMAGE_DEFAULT}
							description="Không có dữ liệu!"
						/>
					),
				}}
			/>
		</div>
	);
};

export default LoggingPayments;
